import { lazy } from 'react';
import { PrivateRouteType, PublicRouteType, RoutesPaths } from './Routes.types';

const Login = lazy(() => import('pages/public/Login'));
const RedirectLogin = lazy(() => import('pages/public/RedirectLogin'));
const ResetPassword = lazy(() => import('pages/public/ResetPassword'));
const PageNotFound = lazy(() => import('pages/private/PageNotFound'));
// const Applications = lazy(() => import('pages/private/Applications'));
const Animals = lazy(() => import('pages/private/Animals'));
const Visitations = lazy(() => import('pages/private/Visitations'));
const Tenants = lazy(() => import('pages/private/Tenants'));
const FAQ = lazy(() => import('pages/private/FAQ'));
const Analytics = lazy(() => import('pages/private/Analytics'));
const Curriculum = lazy(() => import('pages/private/Curriculum'));
const SuggestedTexts = lazy(() => import('pages/private/SuggestedTexts'));
const DocumentUpload = lazy(() => import('pages/private/DocumentsAdd'));
const Landlords = lazy(() => import('pages/private/Landlords'));
const Integration = lazy(() => import('pages/private/Integration'));
const Profile = lazy(() => import('pages/private/Profile'));
export const publicRoutes: PublicRouteType[] = [
  {
    component: Login,
    path: 'login',
  },
  {
    component: ResetPassword,
    path: RoutesPaths.RESET_PASSWORD,
  },
  {
    component: RedirectLogin,
    path: RoutesPaths.REDIRECT,
  },
];

export const privateRoutes: PrivateRouteType[] = [
  // {
  //   title: 'Applications',
  //   component: Applications,
  //   // icon: Icon,
  //   path: RoutesPaths.APPLICATIONS,
  //   show: true,
  // },
  {
    title: 'Visitations',
    component: Visitations,
    // icon: Icon,
    path: RoutesPaths.VISITATIONS,
    show: true,
  },
  {
    title: 'Tenants',
    component: Tenants,
    // icon: Icon,
    path: RoutesPaths.TENANTS,
    show: true,
  },
  {
    title: 'Animals',
    component: Animals,
    // icon: Icon,
    path: RoutesPaths.ANIMALS,
    show: true,
  },
  {
    title: 'Landlords',
    component: Landlords,
    path: RoutesPaths.LANDLORD,
    show: true,
  },
  {
    title: 'Curriculum',
    component: Curriculum,
    path: RoutesPaths.CURRICULUM,
    show: true,
  },
  {
    title: 'Document upload',
    component: DocumentUpload,
    path: RoutesPaths.DOCUMENT_UPLOAD,
    show: true,
  },
  {
    title: 'Suggested Texts',
    component: SuggestedTexts,
    path: RoutesPaths.SUGGESTED_TEXTS,
    show: true,
  },
  {
    title: 'Analytics',
    component: Analytics,
    path: RoutesPaths.ANALYTICS,
    show: true,
  },
  {
    title: 'Integration',
    component: Integration,
    path: RoutesPaths.INTEGRATION,
    show: true,
  },
  {
    title: 'FAQ',
    component: FAQ,
    path: RoutesPaths.FAQ,
    show: true,
  },
  {
    title: 'Profile',
    component: Profile,
    path: RoutesPaths.PROFILE,
    show: false,
  },
  {
    title: '404',
    component: PageNotFound,
    path: RoutesPaths.PAGE_NOT_FOUND,
    show: false,
  },
];
